// Display name and price of the paid, human-delivered feasibility study.
//
// Dependency-free on purpose (same reasoning as
// `sales-forecast.routes-data.ts`): the sales-forecast industry pages and
// the general reports catalogue - `reports-info.ts`, which /pricing renders
// - sell the same product, so neither of them owns the name or the number.
// Importing `industry-config.ts` from the reports catalogue would drag every
// industry's copy, FAQ and SEO tags into the reports/pricing bundles just to
// read two constants.
export const FEASIBILITY_STUDY_NAME = 'Bankable Feasibility Study';

// One flat launch price for every MVP vertical; each `IndustryConfig` still
// carries its own `priceUsd`, seeded from here, so a single industry can be
// repriced later without touching the others.
export const FEASIBILITY_STUDY_PRICE_USD = 1500;

// Display form of the price above, for the catalogues that list prices as
// pre-formatted strings ($399, $4.99, …) rather than numbers.
export const FEASIBILITY_STUDY_PRICE_LABEL = `$${FEASIBILITY_STUDY_PRICE_USD.toLocaleString(
  'en-US'
)}`;
